export default __webpack_public_path__ + "static/x-bc3e69a04bf534c25e8b703b5eb1bdec.mp3";